import { PlanFeature, PlanFeatureCategory, PlanLimitType } from "../enums";
export const LIMIT_LABELS = {
  [PlanLimitType.STORES]: 'số cửa hàng',
  [PlanLimitType.USERS]: 'số người dùng',
  [PlanLimitType.PRODUCTS]: 'số sản phẩm'
};
export const FEATURE_KEY = 'required_feature';
export const LIMIT_KEY = 'check_limit';
export const PLAN_FEATURE_LABELS = {
  [PlanFeature.POS_BASIC]: 'Bán hàng tại quầy',
  [PlanFeature.BARCODE_PRINT]: 'In tem mã vạch',
  [PlanFeature.SCALE_DEVICE]: 'Kết nối cân điện tử',
  [PlanFeature.BULK_PRINT]: 'In hàng loạt',
  [PlanFeature.INVENTORY]: 'Quản lý kho hàng',
  [PlanFeature.GOLD_PRICE]: 'Cập nhật giá vàng',
  [PlanFeature.REPORT_BASIC]: 'Báo cáo cơ bản',
  [PlanFeature.REPORT_ADVANCED]: 'Báo cáo nâng cao',
  [PlanFeature.REPORT_CUSTOM]: 'Báo cáo tùy chỉnh',
  [PlanFeature.CRM]: 'Quản lý khách hàng (CRM)',
  [PlanFeature.E_INVOICE]: 'Hóa đơn điện tử',
  [PlanFeature.MISA_SYNC]: 'Đồng bộ MISA',
  [PlanFeature.API_ACCESS]: 'Truy cập API',
  [PlanFeature.WEBHOOK]: 'Webhook tích hợp',
  [PlanFeature.HARDWARE_PLUGIN]: 'Plugin phần cứng',
  [PlanFeature.MULTI_BRANCH]: 'Quản lý đa chi nhánh',
  [PlanFeature.SUPPORT_247]: 'Hỗ trợ 24/7',
  [PlanFeature.CUSTOM_BRANDING]: 'Thương hiệu tùy chỉnh',
  [PlanFeature.PAYROLL]: 'Quản lý lương',
  [PlanFeature.REFERRAL]: 'Chương trình giới thiệu (Referral)'
};
export const PLAN_FEATURE_CATEGORY_LABELS = {
  [PlanFeatureCategory.POS]: 'Bán hàng',
  [PlanFeatureCategory.INVENTORY]: 'Kho hàng',
  [PlanFeatureCategory.GOLD]: 'Giá vàng',
  [PlanFeatureCategory.REPORT]: 'Báo cáo',
  [PlanFeatureCategory.CRM]: 'Khách hàng',
  [PlanFeatureCategory.INTEGRATION]: 'Tích hợp',
  [PlanFeatureCategory.SYSTEM]: 'Hệ thống'
};
export const PLAN_FEATURE_CATEGORIES = {
  [PlanFeature.POS_BASIC]: PlanFeatureCategory.POS,
  [PlanFeature.BARCODE_PRINT]: PlanFeatureCategory.POS,
  [PlanFeature.SCALE_DEVICE]: PlanFeatureCategory.POS,
  [PlanFeature.BULK_PRINT]: PlanFeatureCategory.POS,
  [PlanFeature.INVENTORY]: PlanFeatureCategory.INVENTORY,
  [PlanFeature.GOLD_PRICE]: PlanFeatureCategory.GOLD,
  [PlanFeature.REPORT_BASIC]: PlanFeatureCategory.REPORT,
  [PlanFeature.REPORT_ADVANCED]: PlanFeatureCategory.REPORT,
  [PlanFeature.REPORT_CUSTOM]: PlanFeatureCategory.REPORT,
  [PlanFeature.CRM]: PlanFeatureCategory.CRM,
  [PlanFeature.E_INVOICE]: PlanFeatureCategory.INTEGRATION,
  [PlanFeature.MISA_SYNC]: PlanFeatureCategory.INTEGRATION,
  [PlanFeature.API_ACCESS]: PlanFeatureCategory.INTEGRATION,
  [PlanFeature.WEBHOOK]: PlanFeatureCategory.INTEGRATION,
  [PlanFeature.HARDWARE_PLUGIN]: PlanFeatureCategory.INTEGRATION,
  [PlanFeature.MULTI_BRANCH]: PlanFeatureCategory.SYSTEM,
  [PlanFeature.SUPPORT_247]: PlanFeatureCategory.SYSTEM,
  [PlanFeature.CUSTOM_BRANDING]: PlanFeatureCategory.SYSTEM,
  [PlanFeature.PAYROLL]: PlanFeatureCategory.SYSTEM,
  [PlanFeature.REFERRAL]: PlanFeatureCategory.CRM
};
/**
 * Trial config — single source of truth dùng cho tenant.signup() +
 * subscription.create(). Khi BO platform có UI quản lý plan (sau), value
 * này sẽ load từ DB (vd plans collection metadata hoặc settings) thay vì
 * hardcode. Không thay đổi tên hằng vì BE đang import qua @erpgold/shared.
 */
export const TRIAL_DURATION_DAYS = 14;

/**
 * Plan slug mặc định khi tenant đăng ký mà không truyền planSlug. Phải
 * khớp với 1 doc trong `plans` collection (slug unique). Migration
 * eg-630-seed-default-plans seed sẵn 4 slug: lite/starter/professional/
 * enterprise. Trial 14 ngày dùng professional theo quyết định 2026-05-08.
 */
export const DEFAULT_TRIAL_PLAN_SLUG = 'professional';
//# sourceMappingURL=plan.constant.js.map